import React, { useRef } from 'react';
import { useFlexLayout, useTable } from 'react-table'

import classNames from 'classnames';

const defaultPropGetter = () => ({});

const TableCell = ({
  index, cell, isLastRow, getColumnProps, getCellProps,
}) => (
  <td
    className={classNames(
      'flex border border-0.5 border-t-0 border-black',
      { 'border-l-0': index > 0 },
      { 'border-b-0': !isLastRow }
    )}
    {...cell.getCellProps([
      {
        className: cell.column.className,
        style: cell.column.style,
      },
      getColumnProps(cell.column),
      getCellProps(cell),
    ])}
  >
    {cell.render('Cell')}
  </td>
)

const TableRow = ({
  index,
  row,
  prepareRow,
  isLastRow = false,
  getRowProps = defaultPropGetter,
  getColumnProps = defaultPropGetter,
  getCellProps = defaultPropGetter,
}) => {
  const rowRef = useRef({});
  prepareRow(row)

  return (
    <tr
      ref={rowRef}
      className={
        classNames(
          'w-full h-full bg-white',
          { 'bg-white': index % 2 === 0 },
          { 'bg-border-light': index % 2 !== 0 },
        )
      }
      {...row.getRowProps({
        ...getRowProps(row),
      })}
    >
      {row.cells.map((cell, cellIndex) => (
        <TableCell
          key={`${row.id}-${cell.column.Header}`}
          cell={cell}
          index={cellIndex}
          isLastRow={isLastRow}
          getColumnProps={getColumnProps}
          getCellProps={getCellProps}
        />
      ))}
    </tr>
  )
}

export const SmallTable = ({
  columns,
  data,
  defaultColumn,
  meta = undefined,
  getHeaderProps = defaultPropGetter,
  getColumnProps = defaultPropGetter,
  getRowProps = defaultPropGetter,
  getCellProps = defaultPropGetter,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      meta,
    },
    useFlexLayout,
  )

  return (
    <table className="h-full w-full bg-border-dark border border-collapse" {...getTableProps()}>
      {headerGroups.map(headerGroup => (
        <thead className="relative h-full w-full" {...headerGroup.getHeaderGroupProps()} style={{ display: 'flex' }}>
          <tr className="h-full w-full flex justify-start">
            {
              headerGroup.headers.map((column, index) => (
                <th
                  className={classNames(
                    'h-full w-full flex items-stretch relative border border-black px-2 py-1',
                    { 'border-l-0': index > 0 },
                  )}
                  {...column.getHeaderProps([
                    {
                      className: column.className,
                      style: column.style,
                    },
                    getColumnProps(column),
                    getHeaderProps(column),
                  ])}
                >
                  {column.render('Header')}
                </th>
              ))
            }
          </tr>
        </thead>
      ))}
      <tbody className="w-full relative" {...getTableBodyProps()}>
        {
          rows?.map((row, index) => (
            <TableRow
              key={row.id}
              row={row}
              index={index}
              prepareRow={prepareRow}
              getCellProps={getCellProps}
              getColumnProps={getColumnProps}
              getRowProps={getRowProps}
              isLastRow={index === rows.length - 1}
            />
          ))
        }
      </tbody>
    </table>
  )
}

export default SmallTable;
